import { ProductsCategoriesTranslations } from "#i18n/translations/pt-BR/org/products/categories";

export const ORG_PRODUCTS_CATEGORIES_ES_ES: ProductsCategoriesTranslations = {
	label: "Categorías",
	search: {
		label: "Buscar",
		placeholder: "Categoría, subcategoría o producto",
	},
	add: "Nueva categoría",
	categoryModal: {
		create: "Crear categoría",
		createSubcategory: "Crear subcategoría",
		edit: "Editar categoría",
		inputs: {
			image: "Foto",
			name: {
				label: "Nombre",
				placeholder: "Ingrese el nombre",
			},
			description: {
				label: "Descripción",
				placeholder: "Describa la categoría",
			},
			priorityLevel: {
				label: "Nivel de prioridad",
				errorMessage: "Ingrese un nivel de prioridad válido (ej: 1, 2, 3...)",
			},
			prefix: "Nivel",
			chartAccount: {
				label: "Plan de Cuentas",
				placeholder: "Seleccione el plan de cuentas",
			},
			printOrder: {
				label: "Fase de la categoría",
				placeholder: "Ingrese la fase de la categoría",
			},
			errors: {
				requiredName: "El nombre es obligatorio",
				requiredPriority: "El nivel de prioridad es obligatorio",
				invalidPriority: "Nivel de prioridad inválido",
				requiredPrintOrder: "La fase de la categoría es obligatoria",
				invalidPrintOrder: "Fase de la categoría inválida",
			},
		},
	},
	columns: {
		product: "Producto",
		systemProduct: "Producto de Sistema",
		actions: "Acciones",
		combo: "Combo",
	},
	noSystemProduct: "Producto de sistema no vinculado",
	priorityLevel: "Nivel de prioridad {{level}}",
	addSubcategory: "Agregar subcategoría en {{category}}",
	addProduct: "Agregar Producto en {{category}}",
	deleteCategory: "¿Desea eliminar la categoría? Esta operación no se puede deshacer.",
	deleteProduct: "¿Desea eliminar este producto? Esta operación no se puede deshacer.",
	productModal: {
		edit: "Editar producto",
		create: "Crear producto",
		inputs: {
			name: {
				label: "Nombre",
				emptyError: "Nombre del producto no completado",
				noStringError: "Use solo caracteres válidos",
				noCategory: "Nombre de la categoría no completado",
				noPriority: "Nivel de prioridad inválido",
			},
			type: {
				label: "Tipo de producto",
				placeholder: "Seleccione un tipo de producto",
				error: "Seleccione un tipo de producto",
			},
			image: "Imagen",
			hasAlcohol: "Contiene Alcohol",
		},
	},
	couvertCannotBeDeleted: "No se puede excluir el cargo de entrada",
	subcategory: "Subcategoría",
	subcategories: "Subcategorías",
	description: "Descripción",
	chartAccount: "Plan de Cuentas",
	products: "Productos",
};
